module.exports = __webpack_public_path__ + "static/media/jeans.0864c509.png";